import React from 'react';
import {Divider} from "antd";

const TableFilterControlsSection = ({ children, showDivider = true }) => {
    return (
        <>
            <div className={'ch-filter-form-section'}>
                {children}
            </div>
            {showDivider && <Divider style={{margin: "12px 0 4px 0"}}/>}
        </>
    );
};

export default TableFilterControlsSection;